<template>
  <subform-controller
    :form-observer="formObserver"
    :is-render-after-fullfilled="isRenderAfterFullfilled"
    :should-question-render="shouldQuestionRender"
    :show-confirm-modal="showConfirmModal"
    :is-subform-visible="questionData.propertyInsuranceClaims"
    :form-items="questionData.claims"
    :subform="FormClaim"
    :max-amount="10"
    :payload-template="CLAIM"
    item-name="claim"
    :step-id="stepId"
    section-item-name="claim"
    @set-items="questionData.claims = $event"
    @set-question="questionData.propertyInsuranceClaims = $event"
  >
    <template #question="{ observer }">
      <form-row
        id="claims"
        label="Have you or anyone living at the property had any insurance claims in the last 5 years?"
      >
        <validation-provider
          v-slot="{ failed }"
          name="Property Insurance Claims"
          :vid="`${stepId}_property-insurance-claims`"
          rules="required"
          slim
        >
          <radio
            v-model="questionData.propertyInsuranceClaims"
            name="property-insurance-claims"
            wide
            :error="failed"
            :items="constants.YES_NO"
            data-test="claims"
          />
        </validation-provider>
      </form-row>

      <help-text :error="formObserver.validated && !observer.valid">
        <component
          :is="isExperimentMinimiseHelptext ? 'show-more' : 'div'"
          open-text="Reporting Past Insurance Claims"
          hide-text="Reporting Past Insurance Claims"
        >
          <p>Insurance providers need to know about any claims you've made from damage to property, items being stolen or injury to other people. You should include these incidents whether or not you made a claim, and whether or not you were paid for that claim. Examples of incidents that insurance providers want to know about are any claim, burglary, vandalism, fire, water or storm damage.</p>
        </component>
      </help-text>
    </template>
    <template
      #preview="{ item: { item } }"
    >
      <subform-preview
        :preview-list="getFormattedSubformPreviewList(item)"
        icon="mdi-home"
      />
    </template>
  </subform-controller>
</template>

<script>
import QuestionBase from '@/components/questions/Base';
import SubformController from '@/components/SubformController/SubformController';
import SubformPreview from '@/components/SubformController/SubformPreview';

import FormClaim from '@/components/home/FormClaim/FormClaim';

import { CLAIM } from '@/payloadTemplates/home';

import { ExtDate } from '@/helpers/date';

export default {
  name: 'question-claims',
  extends: QuestionBase,
  components: {
    SubformController,
    SubformPreview,
  },
  props: {
    showConfirmModal: {
      type: Function,
      required: true,
    },
    isExperimentMinimiseHelptext: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      fields: ['propertyInsuranceClaims', 'claims'],
    };
  },
  methods: {
    formatClaimDate (date) {
      return new ExtDate(date).format('dd MMM yyyy');
    },
    getFormattedSubformPreviewList (item) {
      const {
        claimDate,
        claimAmount,
        claimStatus,
        claimCause,
      } = item;
      return [
        { prepend: this.constants.CLAIM_CAUSE[claimCause] },
        { prepend: this.formatClaimDate(claimDate) },
        { prepend: `£${this.helpers.getNumberFormatted(claimAmount)}` },
        {
          prepend: 'Status:',
          value: this.constants.CLAIM_STATUS[claimStatus],
        },
      ];
    },
  },
  setup () {
    return {
      CLAIM,
      FormClaim,
    };
  },
};
</script>

<style lang="scss" scoped>
.summary-item-wrap {
  list-style: disc;
  margin-left: 5px;
}
</style>
